import { registerPdfFonts } from 'utils/pdf';

registerPdfFonts();

export * from './PdfDocumentDownloadLink';
export * from './FontAwesomeIconPdf';
